import { NetbankingAPI } from "aaa";
import * as _ from "lodash";
import { action, observable } from "mobx";
import { NetbankingAPIClient } from "network/APIClient";
import { IAccount } from "types/account";

export class AccountsStore {
    @observable accounts: IAccount[] = [];
    @observable selectedAccount?: IAccount = undefined;

    @observable isLoading: boolean = false;

    constructor(accounts?: IAccount[]) {
        if (accounts) {
            this.accounts = accounts;
            if (this.accounts && this.accounts.length > 0) {
                this.selectedAccount = this.accounts[0];
            }
        }
    }

    @action async load(usableForQuery?: string, usableForFilter?: string, includesFlag?: string) {
        const target = NetbankingAPI.getAccounts(usableForQuery);
        this.isLoading = true;

        try {
            const accounts = await NetbankingAPIClient.requestType(target);
            if (!usableForFilter && !includesFlag) {
                this.accounts = accounts;
            } else {
                this.accounts = accounts
                    .filter(account => usableForFilter ? account.usableFor && account.usableFor.indexOf(usableForFilter) >= 0 : true)
                    .filter(account => includesFlag ? account.flags && account.flags.includes(includesFlag) : true);
            }

            if (this.accounts && this.accounts.length > 0) {
                this.selectedAccount = this.accounts[0];
            }

            this.isLoading = false;
        } catch (error) {
            this.isLoading = false;
            throw error;
        }
    }

    @action selectAccountByIban(iban: string, filterRest = false) {
        this.selectedAccount = _.find(this.accounts, account => account.accountno.iban === iban);
        if (this.selectedAccount && filterRest) {
            this.accounts = [this.selectedAccount];
        }
    }

    @action selectAccountById(accountId: string) {
        this.selectedAccount = _.find(this.accounts, account => account.id === accountId);
    }

    getAccountById(accountId: string): IAccount | undefined {
        return _.find(this.accounts, account => account.id === accountId);
    }
}



// WEBPACK FOOTER //
// ./src/stores/AccountsStore.ts